import moment from 'moment';
import React from 'react';
import Modal from '../../Components/Modal/Modal';
import RadioButtonGroup from '../../Components/RadioButtonGroup/RadioButtonGroup';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import { Button } from '../../Components/StyledComponents';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './MemoList.scss'
import 'moment/locale/ko'
import axios from 'axios';
import { alertRef } from '../../App';
import { Link } from 'react-router-dom';

const statusList = {
    CancelHistory : '취소사유',
    Normal : '정상처리',
    Cancel : '취소 완료'
}

const variant = {
    CancelHistory : 'primary',
    Normal : 'normal',
    Cancel : 'danger'
}

const MemoList = () => {

    //고객 메모 table column data
    const columnsPoint = React.useMemo(
        () => [
            {
              /* Header: '쿠폰이름을을 검색해보세요.', */
              Header: '가입일',
              accessor: 'RegDate.$date', // accessor is the "key" in the data
              disableSortBy : true,
              Cell : (props) => {
                return (
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
                )
              },
              width : 130,
              minWidth : 130
            },
            {
              Header: '유저번호',
              accessor: 'UserInfo',
              disableSortBy : true,
              minWidth : 130,
              width : 130,
              Cell : (props) => {
                if(typeof props.cell.value !== 'undefined'){
                  return(
                    <Link to={ `/user-info/${props.cell.value._id.$oid}`}>
                      <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                    </Link>
                  )
                }else {
                  return(
                    <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                  )
                }
              }
            },
            {
              /* Header: '쿠폰혜택을 검색해보세요.', */
              Header: '적립 횟수',
              accessor: 'PointCount',
              disableSortBy : true,
              minWidth : 100,
              width : 100,
              Cell : (props) => {
                  return(
                      <p>{convertCost(props.cell.value)}회</p>
                  )
              }
            },
            {
              Header: '잔여 포인트',
              accessor: 'Point',
              disableFilters : true,
              minWidth : 100,
              width : 100,
              Cell : (props) => {
                return(
                    <p>{convertCost(props.cell.value)}P</p>
                )
              }
            },
            {
              Header: '최근 적립일',
              accessor: 'EditDate',
              disableFilters : true,
              Cell : (props) => {
                  return(
                      <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
                  )
              },
              minWidth : 110,
              width : 110
            },
            {
              Header: '메모',
              accessor: 'Memo',
              disableFilters : true,
              Cell : (props) => {
                  return(
                      <p style={{ overflow : 'hidden', textOverflow : 'ellipsis'}}>{props.cell.value.length === 0 ? '(메모 없음)' : props.cell.value}</p>
                  )
              },
              minWidth : 160,
              width : 160
            }
          ],[]
    )

    return (
        <div className='memo-list'>
            <Table columns={columnsPoint} url={'/api/customer/info/need_memo'}/>
        </div>
    )
}

export default MemoList;